import { render, staticRenderFns } from "./loseOrder.vue?vue&type=template&id=33de2c6e&scoped=true&"
import script from "./loseOrder.vue?vue&type=script&lang=js&"
export * from "./loseOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33de2c6e",
  null
  
)

export default component.exports